<template>
  <page-header-wrapper @back="back">
    <template v-slot:breadcrumb>
      {{ formTitle }}
    </template>
    <template v-slot:title>
      {{ formTitle }}
    </template>
    <div class="bg-white padding-lr" ref="container">
      <!-- <InputSearch v-if='codes==1'></InputSearch> -->

      <a-form-model
        ref="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        labelAlign="left"
        :model="form"
        :rules="rules"
      >
        <a-collapse v-model="activeKey">
          <a-collapse-panel key="1" :header="$t('基础信息')" class="goods-collapse">
            <a-row>
              <a-col :span="20">
                <a-form-model-item
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                  :label="$t('商品名称')"
                  prop="goodsName"
                >
                  <a-input v-model="form.goodsName" :maxLength="128" :placeholder="$t('请输入') + $t('商品名称')" />
                </a-form-model-item>
              </a-col>
              <a-col :span="20">
                <a-form-model-item
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                  :label="$t('商品名称英文')"
                  prop="goodsNameEn"
                >
                  <a-input v-model="form.goodsNameEn" :maxLength="128" :placeholder="$t('请输入') + $t('商品名称英文')" />
                </a-form-model-item>
              </a-col>
              <a-col :span="20">
                <a-form-model-item
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                  :label="$t('商品名称俄语')"
                  prop="goodsNameRu"
                >
                  <a-input v-model="form.goodsNameRu" :maxLength="128" :placeholder="$t('请输入') + $t('商品名称俄语')" />
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="12">
                <a-form-model-item
                  :label-col="{ span: 5 }"
                  :wrapper-col="{ span: 11 }"
                  :label="$t('商品类型')"
                  prop="categoryId"
                >
                  <a-select v-model="form.categoryId" placeholder="请选择商品类型">
                    <a-select-option v-for="item in categoryList" :value="item.id" :key="item.id">
                      {{ item.categoryName }}</a-select-option
                    >
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12" v-if="form.id">
                <a-form-model-item
                  :label-col="{ span: 5 }"
                  :wrapper-col="{ span: 11 }"
                  :label="$t('商品状态')"
                  prop="status"
                >
                  <a-select v-model="form.status" placeholder="请选择状态">
                    <a-select-option :value="1">上架</a-select-option>
                    <a-select-option :value="0">下架</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="12">
                <a-form-model-item label="商品主图" prop="picture" :label-col="{ span: 5 }" :wrapper-col="{ span: 11 }">
<!--                  <cos-upload
                    type="image"
                    :defaultList="form.pictureArr"
                    :count="1"  :imgSize="'339*339'"
                    @input="getImg($event, 'picture')"
                  ></cos-upload>-->
                  <vod-upload type="image" :defaultList="form.pictureArr" :count="1" :imgSize="'339*339'"
                                   @input="getImg($event, 'picture')"></vod-upload>
<!--                  <a-upload
                    listType="picture-card"
                    class="avatar-uploader"
                    v-model="form.pictureArr"
                    :showUploadList="false"
                    action="https://web.frameflash.com/admin-api/common/local/file/uploadCos"
                    :beforeUpload="beforeUploadPicture"
                    :customRequest="handleChangePicture"
                  >
                    <plus-outlined />
                    <img v-if="form.picture" :src="form.picture" alt=""
                         style="height:104px;max-width:300px"/>
                    <div v-else>
                      <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
                      <div class="ant-upload-text">上传</div>
                    </div>
                  </a-upload>-->
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="相册" prop="photoAlbum" :label-col="{ span: 5 }" :wrapper-col="{ span: 11 }">
<!--                  <file-upload
                    type="image"
                    :defaultList="form.photoAlbumArr"
                    :count="6"  :imgSize="'750*750'"
                    @input="getImg($event, 'photoAlbum')"
                  ></file-upload>-->
<!--                  <a-upload
                    listType="picture-card"
                    class="avatar-uploader"
                    v-model="form.photoAlbum"
                    :file-list="form.photoAlbumArr"
                    action="https://web.frameflash.com/admin-api/common/local/file/uploadCos"
                    :beforeUpload="beforeUploadPhotoAlbum"
                    :customRequest="handleChangePhotoAlbum"
                  >
                    <plus-outlined />
                    <img v-if="form.photoAlbumArr" v-for="item in form.photoAlbumArr" :src="item" alt=""
                         style="height:104px;max-width:300px"/>
                    <div v-else>
                      <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
                      <div class="ant-upload-text">上传</div>
                    </div>
                  </a-upload>-->
                  <vod-upload type="image" :defaultList="form.photoAlbumArr" :count="7" :imgSize="'339*339'"
                              @input="getImg($event, 'photoAlbum')"></vod-upload>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item
                  label="运费模板"
                  prop="deliveryTemplateId"
                  :label-col="{ span: 5 }"
                  :wrapper-col="{ span: 11 }"
                >
                  <a-select v-model="form.deliveryTemplateId" placeholder="请选择运费模板">
                    <a-select-option
                      v-for="item in shippingTemplates"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      >{{ item.name }}</a-select-option
                    >
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>
<!--            <a-row>
              <a-col :span="12">
                <a-form-model-item label="展示类型" prop="type">
                  <a-select v-model="form.type" @change="editType" placeholder="请选择展示类型">
                    <a-select-option :key="1">剧集展示</a-select-option>
                    <a-select-option :key="2">宣传片展示</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>-->
<!--            <a-row>
              <a-col :span="12">
                <a-form-model-item label="短剧名称" prop="videoId">
                  <a-select
                    v-model="form.videoId"
                    showSearch
                    style="width: 100%"
                    placeholder="请选择短剧"
                    @change="getGatherList"
                    allow-clear
                    optionFilterProp="children"
                  >
                    <a-select-option :value="item.id" :key="item.id" :title="item.videoName" v-for="(item,index) in listAll">
                      {{ item.videoName }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>-->
<!--            <a-row>
              <a-col :span="12">
                <a-form-model-item label="剧集" prop="gatherId" >
                  &lt;!&ndash;        <a-input v-model="form.videoId" placeholder="请输入短剧id" />&ndash;&gt;
                  <a-select
                    v-model="form.gatherId"
                    showSearch
                    style="width: 100%"
                    placeholder="请选择剧集"
                    allow-clear
                    optionFilterProp="children"
                  >
                    <a-select-option :value="item.id" :key="item.id" :title="item.serialNumber" v-for="(item,index) in gatherList">
                      第{{item.serialNumber}}集
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </a-row>-->
          </a-collapse-panel>

          <a-collapse-panel key="3" :header="$t('规格信息')" class="goods-collapse">
            <a-row>
              <a-col span="2" v-if="specDisable">
                <a-button
                  :disabled="!specDisable"
                  type="primary"
                  style="width: 100%"
                  @click="editSpec"
                  class="margin-bottom"
                >
                  <a-icon type="edit" />
                  {{ $t('修改规格') }}
                </a-button>
              </a-col>
              <a-col :span="20"> </a-col>
            </a-row>

            <div  :disabled="specDisable">
              <a-form-model-item  :label-col="{ span: 5 }" :wrapper-col="{ span: 13 }" style="margin-left: 163px">
                <a-select
                  :disabled="specDisable"
                  v-model="form.specIds"
                  show-search
                  :filter-option="filterOption"
                  placeholder="请选择规格"
                  style="width: 200px; margin-bottom: 0px"
                  @change="handleChangeSpec"
                >
                  <a-select-option
                    :value="item.id"
                    :label="item.specName"
                    v-for="(item, index) in specList"
                    :key="item.id"
                  >
                    {{ item.specName }}
                  </a-select-option>
                </a-select>
                <a-button
                  style="margin-left: 8px; background-color: #73859f; border: 1px solid #73859f"
                  type="primary"
                  @click="showModals(form.specIds)"
                  >+规格
                </a-button>
                <a-button
                  style="margin-left: 8px; background-color: rgb(250, 173, 20); border: 1px solid rgb(250, 173, 20)"
                  type="primary"
                  :disabled="specDisable"
                  @click="confirmSpecBtns(form)"
                  >+规格值</a-button
                >
              </a-form-model-item>
              <div   v-for="(item, id) in form.specList" :key="item.index">
                <a-row>
                  <a-col :span="15">
                    <a-form-model-item :label-col="{ span: 4 }" :wrapper-col="{ span: 50 }" style="margin-left: 163px">
                      <a-table
                        size="small"
                        style="width: 100%"
                        :data-source="item.specValueList"
                        :columns="specValueColumns"
                        rowKey="id"
                        :pagination="false"
                        bordered
                      >
                        <div slot="tsName" slot-scope="text, record">
                          <b>{{ record.tsName }}</b>
                        </div>
                        <div slot="specValueName" slot-scope="text, record">
                          <a-input
                            :disabled="specDisable"
                            v-model="record.specValueName"
                            :maxLength="16"
                            placeholder="请输入规格"
                            @blur="changeGuigeshuju(item, record)"
                          />
                        </div>

                        <div slot="valuePicture" slot-scope="text, record"></div>
                        <div slot="action" slot-scope="text, record">
                          <a-popconfirm
                            title="确定要删除此规格值吗？"
                            ok-text="确定"
                            cancel-text="取消"
                            v-if="!specDisable"
                            @confirm="delSpecValue(item, record)"
                          >
                            <a href="javascript:void(0)" style="color: red">删除</a>
                          </a-popconfirm>
                        </div>
                      </a-table>
                    </a-form-model-item>
                  </a-col>

                  <span style="color: red" v-if="item.specErrorMessage">{{ item.specErrorMessage }}</span>
                </a-row>
              </div>
              <div>
                <a-row>
                  <a-col :span="12">
                    <a-button class="margin-tb" type="primary" @click="generateSkus" :disabled="specDisable"
                      >生成sku</a-button
                    >
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="20" :offset="2">
                    <a-table
                      :loading="skuLoading"
                      :data-source="form.skuList"
                      :columns="skuColumns"
                      rowKey="id"
                      :pagination="false"
                      bordered
                    >
                      <div slot="skuName" slot-scope="text, record">
                        {{ record.skuName }}
                      </div>
                      <div slot="skuNameEn" slot-scope="text, record">
                        <a-input
                          :disabled="specDisable"
                          style="width: 100%"
                          v-model="record.skuNameEn"
                          :placeholder="$t('请输入') + $t('SKU英文名称')"
                          @blur.native.capture="validatorSku"
                        />
                      </div>
                      <div slot="skuNameRu" slot-scope="text, record">
                        <a-input
                          :disabled="specDisable"
                          style="width: 100%"
                          v-model="record.skuNameRu"
                          :placeholder="$t('请输入') + $t('SKU俄语名称')"
                          @blur.native.capture="validatorSku"
                        />
                      </div>

                      <div slot="skuPrice" slot-scope="text, record">
                        <a-input
                          :disabled="specDisable"
                          v-model="record.price"
                          :placeholder="$t('请输入') + $t('商品价格')"
                          @blur.native.capture="validatorSku"
                        />
                      </div>
                      <span slot="operation" slot-scope="text, record">
                        <a @click="handleDelete(record)" >
                          <a-icon type="delete" />删除
                        </a>
                     </span>

                      <div slot="skuPrice" slot-scope="text, record">
                        <a-input
                          :disabled="specDisable"
                          v-model="record.price"
                          :placeholder="$t('请输入') + $t('价格')"
                          @blur.native.capture="validatorSku"
                        />
                      </div>
                      <div slot="stock" slot-scope="text, record">
                        <a-input-number
                          :disabled="specDisable"
                          style="width: 100%"
                          v-model="record.stock"
                          :placeholder="$t('请输入') + $t('商品库存')"
                          @blur.native.capture="validatorSku"
                        />
                      </div>
                      <div slot="valuePicture" slot-scope="text, record">
<!--                        <file-upload
                          style="width: 100%"
                          type="image"
                          :defaultList="record.imageArr"
                          :count="1"
                          @input="getImgs($event, 'image', record)"
                        ></file-upload>-->
                        <vod-upload type="image" :defaultList="record.imageArr" :count="1" :imgSize="'339*339'"
                                    @input="getImgs($event, 'image', record)"></vod-upload>
                      </div>
                      <div slot="skuWeight" slot-scope="text, record">
                        <a-input-number
                          :disabled="specDisable"
                          style="width: 100%"
                          v-model="record.weight"
                          :placeholder="$t('请输入') + $t('重量')"
                          @blur.native.capture="validatorSku"
                        />
                      </div>
                    </a-table>
                    <span style="color: red" v-if="skuErrorMessage">{{ skuErrorMessage }}</span>
                  </a-col>
                </a-row>
              </div>
            </div>
          </a-collapse-panel>
          <a-collapse-panel key="4" :header="$t('商品详情')" class="goods-collapse">
            <a-row>
              <a-col :span="24">
                <a-form-model-item
                  :label-col="{ span: 2 }"
                  :wrapper-col="{ span: 22 }"
                  :label="$t('')"
                  prop="description"
                >
                  <editor v-model="form.description" :placeholder="$t('请输入') + $t('商品详情')" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-collapse-panel>
        </a-collapse>


        <div class="bottom-control" style="margin-bottom: 30px;">
          <a-space>
            <a-button type="primary" :loading="submitLoading" @click="submitForm">
              {{ $t('保存') }}
            </a-button>
            <a-button type="dashed" @click="cancel">
              {{ $t('取消') }}
            </a-button>
          </a-space>
        </div>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
        <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
          <video
            style="width: 100%"
            :src="previewUrl"
            ref="myVideo"
            :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'"
            :controls="true"
          ></video>
        </a-modal>
      </a-form-model>

      <radio-freight-select-form
        ref="RadioFreightSelectForm"
        @freightSelect="indexFreightTemplateSelect"
      ></radio-freight-select-form>

    </div>
  </page-header-wrapper>
</template>

<script>
import { getGoodsInfo, addGoodsInfo, updateGoodsInfo, Delete } from '@/api/goods/goodsInfo'
import { listGoodsCategory } from '@/api/goods/goodsCategory'
import { guid } from '@/utils/ruoyi'
import { addSpecValue, delSpecValue, updateSpecValue } from '@/api/goods/specValue'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import Editor from '@/components/Editor'
import {getGatherList} from "@/api/video/publicize";


import { shippingTemplates } from '@/api/logistics'
import RadioFreightSelectForm from '@/views/mall/template/RadioSelectForm'
import skuAddsku from '@/views/goods/sku/addSku'
import { listSpec, addSpec } from '@/api/goods/spec'
import InputForms from './InputForms'
import InputSearch from './InputSearch'
import {delSku} from "@/api/goods/sku";
import CosUpload from "@/components/FileUpload/indexCos";
import UploadFileToVOD from "@/api/vod";
import {listVideo} from "@/api/video/video";

export default {
  name: 'CreateForms',
  props: {},
  components: {
    CosUpload,
    Editor,
    RadioFreightSelectForm,
    CustomDictTag,
    skuAddsku,
    InputForms,
    InputSearch,
  },
  data() {
    return {
      listAll: [],
      gatherList: [],
      uploadLoading:false,
      skuList: [],
      isDel: 0,
      isrebate: [
        {id: 1, name: '是'},
        {id: 0, name: '否'},
      ],
      // 接收后端返回的form
      form_reList: {},
      isTable: false,
      confirmLoading: false,
      visible: false,
      guigeId: '',
      listGetData: [],
      specValueList: [],
      specList: [],
      curSpec: null,
      companyList: [],
      customDict: {
        TFEnum: [
          {type: 1, name: '是'},
          {type: 0, name: '否'},
        ],
      },
      shippingTemplates: [],
      tabIndex: 1,
      categoryList: [],
      labelList: [],
      /*是否有规格图片*/
      isSpecPic: false,
      /*分类的回显*/
      categorySelected: [],
      labelCol: {span: 4},
      activeKey: [1, 2, 3, 4],
      wrapperCol: {span: 16},
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      skuLoading: false,
      imgList: [],
      skuErrorMessage: undefined,
      errorMessage: undefined,
      localeColumns: [
        {
          title: this.$t('语言'),
          dataIndex: 'locale',
          key: 'locale',
          scopedSlots: {customRender: 'locale'},
        },
        {
          title: this.$t('商品名称'),
          dataIndex: 'name',
          scopedSlots: {customRender: 'name'},
          key: 'name',
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          key: 'action',
          slots: {title: 'addbtn', customRender: 'brandName'},
          scopedSlots: {customRender: 'action'},
        },
      ],
      specValueColumns: [
        {
          title: this.$t('规格名'),
          dataIndex: 'tsName',
          width: 150,
          key: 'tsName',
          scopedSlots: {customRender: 'tsName'},
        },
        {
          title: this.$t('规格值'),
          width: 200,
          dataIndex: 'specValueName',
          key: 'specValueName',
          scopedSlots: {customRender: 'specValueName'},
        },

        {
          title: this.$t('操作'),
          dataIndex: 'action',
          width: 200,
          key: 'action',
          slots: {title: 'addbtn', customRender: 'name'},
          scopedSlots: {customRender: 'action'},
        },
      ],


      skuColumns: [
        {
          title: this.$t('SKU名称'),
          width: 200,
          key: 'skuName',
          scopedSlots: {customRender: 'skuName'},
        },
        {
          title: this.$t('SKU名称 英文'),
          dataIndex: 'skuNameEn',
          width: 200,
          key: 'skuNameEn',
          scopedSlots: {customRender: 'skuNameEn'},
        },
        {
          title: this.$t('SKU名称 俄语'),
          dataIndex: 'skuNameRu',
          width: 200,
          key: 'skuNameRu',
          scopedSlots: {customRender: 'skuNameRu'},
        },
        {
          title: this.$t('规格图片'),
          dataIndex: 'picture',
          key: 'picture',
          width: 200,
          scopedSlots: {customRender: 'valuePicture'},
        },
        {
          title: this.$t('库存'),
          dataIndex: 'stock',
          width: 200,
          key: 'stock',
          scopedSlots: {customRender: 'stock'},
        },
        {
          title: this.$t('价格'),
          dataIndex: 'price',
          width: 200,
          key: 'price',
          scopedSlots: {customRender: 'skuPrice'},
        },
        {
          title: this.$t('重量(kg)'),
          dataIndex: 'weight',
          width: 200,
          key: 'weight',
          scopedSlots: {customRender: 'skuWeight'},
        },

        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: {customRender: 'operation'},
          align: 'center'
        }
      ],
      specDisable: false,
      /*是否发生了规格变动如果有则保存到后台时会先执行删除商品操作 后执行添加商品操作  如果没有则 直接修改*/
      isChangeSpec: false,
      // 表单参数
      form: {
        id: null,
        price: null,
        saleAmount: null,
        status: 0,
        type: 0,
        videoId: null,
        isChangeSpec: false,
        specList: [],
        skuList: [],
        specValueList: [],
        imgList: [],
        freightTemplateDetail: null,
        goodsName: null,
        pictureCount: 1,
        pictureArr: [],
        picture: null,
        photoAlbumCount: 6,
        photoAlbumArr: [],
        photoAlbum: null,
        weight: null,
        imgIdArray: null,
        categoryId: null,
        freightTemplateId: null,
        stock: null,
        alarmStock: null,
        description: null,
        isRecommend: null,
        sort: null,
        remark: null,
      },
      codes: 0,
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        type: [{required: true, message: '商品分类不能为空', trigger: 'change'}],
        goodsName: [{required: true, message: '商品名称 不能为空', trigger: 'blur'}],
        goodsCode: [{required: true, message: '商品编码 不能为空', trigger: 'blur'}],
        zoneType: [{required: true, message: '专区类型不能为空', trigger: 'change'}],
        categoryId: [{required: true, message: '商品类型不能为空', trigger: 'blur'}],
        deliveryTemplateId: [{required: true, message: '运费模板不能为空', trigger: 'blur'}],
        picture: [{required: true, message: '商品主图不能为空', trigger: 'blur'}],
        photoAlbum: [{required: true, message: '相册不能为空', trigger: 'blur'}],
        price: [{required: true, message: '商品价格不能为空', trigger: 'blur'}],
        stock: [{required: true, message: '商品库存不能为空', trigger: 'blur'}],
        // requireScores: [
        //   { required: true, message: '需要积分数量不能为空', trigger: 'blur' }
        // ],
        cashCoupon: [{required: true, message: '需要现金券数量不能为空', trigger: 'blur'}],
        status: [{required: true, message: '状态不能为空', trigger: 'blur'}],
      },
    }
  },
  filters: {},
  created() {
    // this.getCategoryList()
    // this.getBrandList()
    // this.getLabelList()


  },
  computed: {
    // ...mapGetters(['customDict']),
  },
  watch: {},
  mounted() {
    this.form.id = this.$route.query.goodsId
    let copy = this.$route.query.copy
    this.codes = this.$route.query.codes
    if (this.$route.query.type == 3 || this.$route.query.type == 4) {
      this.skuColumns = this.skuColumns.filter((col) => col.dataIndex !== 'cashCoupon')
    }



    // this.$store.commit('tagsView/ADD_ACTIVE_INDEX',2)
  },
  activated() {
    this.initDate()
    this.form.id = this.$route.query.goodsId
    this.codes = this.$route.query.codes
    let copy = this.$route.query.copy
    if (this.codes == 1) {
      this.handleUpdate(this.form.id, copy)
    } else {
      this.handleAdd()
    }
    // this.initDate()
  },

  methods: {
    getGather() {
      listVideo().then(res => {
        this.listAll = res.data;
      })
    },
    getGatherList(value) {
      getGatherList({"id": value}).then(res => {
        this.gatherList = res.data;
      })
    },
    editType(value) {
      this.type = value;
    },
    beforeUploadPhotoAlbum: function (file) {
      var fileType = file.type;
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        this.uploadLoading=false
        return false;
      }
      this.form.photoAlbumArr=""
      //TODO 驗證文件大小
    },
    handleChangePhotoAlbum(info) {
      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.photoAlbumArr.push(fileName[0]);//文件名
          that.uploadLoading = false;
        },
      });
      that.uploadLoading = false;
    },
    beforeUploadPicture: function (file) {
      var fileType = file.type;
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        this.uploadLoading=false
        return false;
      }
      this.form.pictureArr=""
      //TODO 驗證文件大小
    },
    handleChangePicture(info) {
      let that = this
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.pictureArr = fileName[0];//文件名
          that.form.picture = fileName[0];
          that.uploadLoading = false;
        },
      });
      that.uploadLoading = false;
    },

    handleDelete(val) {
      let int = this.form.skuList.indexOf(val)
      this.form.skuList.splice(int, 1)
      if (val.id) {
        delSku([{id: val.id}]).then(res => {
          if (res.success) {
            this.$message.success('成功')
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },

    showModals(val) {
      console.log(val, 'val', this.form.specIds)
      var isspecsTip = 0
      this.specList.forEach((it) => {
        if (it.id == val) {
          isspecsTip = 1
        }
      })
      if (isspecsTip == 1) {
        this.$message.error('已存在同名规格，请勿重复添加')
      } else {
        addSpec({specName: this.form.specIds}).then((res) => {
          if (res.code == 20001) {
            this.form.specIds = res.data.id
            this.$message.success('规格添加成功')
            listSpec({isDeleted: 0}).then((res) => {
              this.specList = res.data
            })
          } else {
            this.$message.error('规格添加失败')
            listSpec({isDeleted: 0}).then((res) => {
              this.specList = res.data
            })
          }
        })
      }
    },
    handleCancel() {
      this.visible = false
    },
    handleOk() {
    },

    initDate() {

      shippingTemplates({isDeleted: 0}).then((res) => {
        this.shippingTemplates = res.data
      })
      listSpec({isDeleted: 0}).then((res) => {
        this.specList = res.data
      })
      this.categoryList = []
      listGoodsCategory({isDeleted: 0}).then((res) => {
        this.categoryList = res.data
      })
    },
    handleChangeSpec(e) {
      this.curSpec = e
    },
    filterOption(input, option) {
      this.valGuiGe = input
      this.form.specIds = input

      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },


    container() {
      return this.$refs.container
    },

    /*锚点*/
    getCurrentAnchor() {
      return '#components-anchor-demo-static'
    },
    changeTab(index, type) {
      if (type === 'next') {
        let isValid = false
        this.$refs.form.validate((valid) => {
          isValid = valid
        })
        if (!isValid) {
          console.log('有必填项未填')
          return
        }
        this.tabIndex = index + 1
      } else if (type === 'back') {
        this.tabIndex = index - 1
      }
    },
    isSpecPicChange(e) {
      //其他规格就不能有图片了
      this.isSpecPic = e.target.value
    },
    // sku生成
    generateSkus() {
      this.skuLoading = true
      this.form.skuList = []
      let skuValueList = []
      //拿到所有的sku值
      let that = this
      console.log("生成sku1111111111111", this.form.specList)
      this.form.specList.forEach((spec) => {
        spec.specValueList.forEach((specValue) => {
          that.changeGuigeshuju(spec, specValue)
        })
      })
      this.form.specList.forEach((spec) => {
        skuValueList.push(spec.specValueList)
      })
      //递归,求笛卡尔积
      console.log("============skuValueList", skuValueList)
      let sku = this.cartesianProduct(skuValueList)
      let flag = false
      sku.forEach(item => {
        item.forEach(spec => {
          if (!spec.specValueName) {
            flag = true
            return
          }
        })
      })
      if (flag == true) {
        this.$message.error("规格值不能为空")
        this.skuLoading = false
        return
      }
      //把这些sku 组装一下放到skuList里
      if (!this.form.skuList) {
        this.form.skuList = []
      }

      sku.forEach((e) => {
        console.log("==========sku======", e)
        let name = ''
        let skuPic = ''
        let specValueIds = ''
        let specValueId = ''
        let specId = ''
        var specSpecValueList = []
        var specValueName = ''
        e.forEach((j) => {
          specValueName = j.specValueName
          if (name) {
            name += '-' + j.specValueName
          } else {
            name += j.specValueName
          }
          specSpecValueList.push({specId: j.specId, specValueId: j.id})
          console.log("==========specSpecValueList======", specSpecValueList)
          specValueIds += j.id + ':'
          if (j.picture) {
            skuPic = j.picture
          }
        })
        specValueIds = specValueIds.substring(0, specValueIds.length - 1)
        const newData = {
          id: null,
          skuName: name,
          skuNameEn: null,
          skuNameRu: null,
          price: null,
          // picture: skuPic,
          pictureCount: 1,
          pictureArr: [],
          picture: null,
          specSpecValueList: specSpecValueList,
          specValueIds: specValueIds,
          stock: null,
          weight: 0,
        }
        that.form.skuList.push(newData)
      })

      console.log(this.form, '生成sku2222222', this.listGetData)

      this.skuLoading = false
    },

    cartesianProduct(arr) {
      if (arr.length === 0) {
        return [[]]
      }
      const result = []
      const rest = this.cartesianProduct(arr.slice(1))
      for (let i = 0; i < arr[0].length; i++) {
        for (let j = 0; j < rest.length; j++) {
          result.push([arr[0][i], ...rest[j]])
        }
      }
      return result
    },
    onClose() {
      this.open = false
      this.reset()
      this.back()
    },
    // 取消按钮
    cancel() {
      this.open = false
      // this.reset()
      // this.back()
      this.$router.go(-1)
    },

    openFreightTemplateSelect() {
      this.$refs.RadioFreightSelectForm.openList(this.form.freightTemplateId)
    },
    indexFreightTemplateSelect(record) {
      this.form.freightTemplateId = record.id
      this.form.freightTemplateDetail = record
    },

    // 表单重置
    reset() {
      this.formType = 1
      this.categorySelected = []
      this.specDisable = false
      this.isChangeSpec = false
      this.form = {
        id: null,
        specIds: "",
        isChangeSpec: false,
        isSpecId: false,
        specList: [],
        specValueList: [],
        skuList: [],
        freightTemplateDetail: null,
        goodsName: null,
        status: 0,
        type: 0,
        imgList: [],
        picture: null,
        imgIdArray: null,
        categoryId: null,
        price: null,
        pictureCount: 1,
        pictureArr: [],
        photoAlbumCount: 6,
        photoAlbumArr: [],
        photoAlbum: null,
        freightTemplateId: null,
        stock: null,
        alarmStock: null,
        description: null,
        descriptionEn: null,
        sort: null,
        weight: null,
        remark: null,
      }
    },

    /*x限制只能输入数字,并限定最大值*/
    limitWeight() {
      // console.log(i);
      let val = this.form.weight.replace(/^\D*([0-9]\d*\.?\d{0,3})?.*$/, '$1')
      if (val == null || val == undefined || val == '' || val < 0) {
        val = 0
      }
      if (val > 21474836) {
        val = 21474836
      }
      this.form.weight = val
    },



    validatorSku() {
      if (!this.form.skuList) {
        return true
      }
      let message = ''
      let that = this
      this.form.skuList.forEach((e) => {
        let skuErrorMessage = ''
        if (e.price <= 0) {
          skuErrorMessage += this.$t('sku.价格') + this.$t('不能小于0') + '; '
        }
        if (e.stock <= 0) {
          skuErrorMessage += this.$t('sku.库存') + this.$t('不能小于0') + '; '
        }
        message = skuErrorMessage
      })
      if (message) {
        this.skuErrorMessage = message
        return false
      }
      this.skuErrorMessage = ''
      return true
    },
    // 输入规格时
    validatorSpecValue(item, record) {
      let specErrorMessage = ''
      item.specErrorMessage = undefined
      this.listGetData.forEach((items, i) => {
        if (items.id == record.id) {
          // items.id = record.id
          items.specValueName = record.specValueName
        }
      })
      console.log(this.listGetData, "this.listGetData")
      return true
    },

    validatorSpecValueAll() {
      let result = true
      this.form.specList.forEach((spec) => {
        let specErrorMessage = ''
        spec.specValueList.forEach((e) => {
          if (!e.specValueName) {
            specErrorMessage += this.$t('规格值') + this.$t('不能为空')
          }
        })
        if (specErrorMessage) {
          spec.specErrorMessage = specErrorMessage
          result = false
        } else {
          spec.specErrorMessage = undefined
        }
      })

      return result
    },



    getFreightName() {
      if (this.form.freightTemplateId && this.form.freightTemplateDetail) {
        return this.form.freightTemplateDetail.name
      } else {
        return this.$t('请选择') + this.$t('运费模板')
      }
    },


    /*分类的选择*/
    onCategoryChange(value, selectedOptions) {
      this.form.categoryId = value[1]
    },

    addSpec() {
      let validatorSpec = this.validatorSpecValueAll()
      if (!validatorSpec) {
        return
      }
      const index = this.form.specList.length + 1
      const newData = {
        id: null,
        specId: "",
        specDesc: null,
        isHaveImg: false,
        sort: index,
        specValueList: [],
      }

      this.form.specList.push(newData)
    },
    editSpec() {
      this.specDisable = false
      this.isDel = 1
      /*是否发生了规格变动如果有则保存到后台时会先执行删除商品操作 后执行添加商品操作  如果没有则 直接修改*/
      this.isChangeSpec = true
      //修改规格后,清空所有sku
      // this.form.skuList = []
    },
    delSpec(id) {
      this.form.specList.splice(id, 1)
      this.generateSkus()
    },
    changeGuigeshuju(item, record) {
      console.log('改变了', record.id,)
      if (record.id) {
        var postData = {
          goodsId: this.form.goodsId,
          id: record.id,
          remark: record.tsName,
          specId: record.specId,
          specValueName: record.specValueName,
        }
        updateSpecValue(postData).then((res) => {
          if (res.code == 20001) {
            // this.$set(record, 'id', res.data.id)
          } else {
            this.$message.info('修改失败,请重试')
          }
        })
      } else {
        if (record.specValueName) {
          record.goodsId = this.form.goodsId
          var postData = {
            goodsId: record.goodsId,
            remark: record.tsName,
            specId: record.specId,
            specValueName: record.specValueName,
          }
          addSpecValue(postData).then((res) => {
            if (res.code == 20001) {
              this.$set(record, 'id', res.data.id)
              // 新加的这块

              this.listGetData = this.form.specValueList.map((item, i) => {
                return {
                  id: item.id, //输入的规格值id
                  specValueName: item.specValueName,
                  goodsId: 0,
                  specId: item.specId,
                }
              })
              console.log(this.listGetData, "listGetDatajiaoyan")

              //  ==
              console.log('改变后', item)
            } else {
              this.$message.info('增加失败,请重试')
            }
          })
        }
      }
      this.listGetData.forEach((items, i) => {
        if (items.id == record.id) {
          // items.id = record.id
          items.specValueName = record.specValueName
        }
      })


    },
    // 01
    confirmSpecBtns(item) {
      console.log("规格", this.form.specIds)
      let spec = this.specList.find(item => item.id == this.form.specIds)
      if (!spec) {
        this.$message.error('规格不能为空')
      } else {
        this.isTable = true
        var tsName = spec.specName

        let index = item.id * 100 + item.specValueList.length + 1
        const newData = {
          index: index,
          id: null, //输入的规格值id
          specValueName: null,
          specId: item.specIds,
          picture: null,
          pictureArr: [],
          pictureCount: 1,
          goodsId: 0,
          isVisible: true,
          specErrorMessage: undefined,
          sort: 0,
          tsName: tsName,
        }

        const newDataf = {
          id: null, //输入的规格值id
          specValueName: '',
          goodsId: 0,
          specId: newData.specId,
        }
        this.form.specValueList.push(newData)
        this.form.specValueList = this.form.specValueList.filter((e) => e.hasOwnProperty('tsName'))
        this.form.specList.concat(this.form.specValueList)
        this.listGetData.push(newDataf)
        console.log('listGetDa+', this.form.specValueList)
        this.listGetData = this.listGetData.filter((e) => e.hasOwnProperty('tsName'))
        console.log('listGetDatas', this.listGetData)
        // 把拿到的form.specList进行分类
        const list2 = this.form.specValueList.reduce((pre, cur, index) => {
          let obj = {}
          if (index == 0) {
            obj.specId = cur.specId
            // obj.id = cur.id
            obj.specValueList = [cur]
            pre.push(obj)
          } else {
            const i = pre.findIndex((item) => item.specId == cur.specId)
            if (i > -1) {
              pre[i].specValueList.push(cur)
            } else {
              obj.specId = cur.specId
              // obj.id = cur.id
              obj.specValueList = [cur]
              pre.push(obj)
            }
          }
          return pre
        }, [])

        this.form.specList = list2

        console.log(list2, "加规格值", item, this.form.specValueList, this.listGetData, "this.listGetData")
      }
    },

    addSpecValue(item) {
      let validatorSpecValue = this.validatorSpecValue(item)
      if (!validatorSpecValue) {
        return
      }
      let index = item.id * 100 + item.specValueList.length + 1
      const newData = {
        index: index,
        id: index,
        specValueName: null,
        specName: item.specName,
        picture: null,
        pictureArr: [],
        pictureCount: 1,
        isVisible: true,
        specErrorMessage: undefined,
        sort: 0,
      }
      item.specValueList.push(newData)
    },
    delSpecValue(item, record) {
      item.specValueList = item.specValueList.filter((e) => e.id !== record.id)
      this.form.specValueList = this.form.specValueList.filter((e) => e.id !== record.id)
      this.form.specList = this.form.specList.filter((e) => e.specValueList.length != 0)
      this.listGetData = this.form.specValueList
      console.log(record.id, this.form.specValueList, "删除规格", item.specValueList, "this.listGetData")
    },

    getLimitOne(index, specValueList) {
      //不可用的list
      let visibleList = specValueList.filter((obj) => obj.isVisible === true)
      //可见list里是否有自己
      let selfBoolean = visibleList.filter((obj) => obj.index === index).length >= 1
      //如果不可用的小于一个
      let count = visibleList.length
      //如果可用的小于一个,并且自己还是可用的,返回disable
      return selfBoolean && count <= 1
    },

    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.getGather()
      this.isDel = 0
      // this.formType = 1
      // this.initLocale()
      this.formTitle = this.$t('添加')
      // let copy = this.$route.query.copy
      this.codes = this.$route.query.codes

      //this.form.type = this.$route.query.type * 1
      this.form.status = 0
      //this.initCategory(this.$route.query.type)

      this.initDate()
    },

    /** 修改跳转操作 */
    handleUpdate(id, copy) {
      this.reset()
      this.isDel = 0
      this.formType = 2
      this.getGather()
      this.specDisable = true
      getGoodsInfo({id: id}).then((response) => {
        this.$set(this, 'form', JSON.parse(JSON.stringify(response.data)))
        this.$set(this, 'form_reList', JSON.parse(JSON.stringify(response.data)))
        this.getGatherList(this.form.videoId)

        this.$set(this.form, 'stock', response.data.goodStock)
        this.$set(this.form, 'price', response.data.price)
        this.form.deliveryTemplateId = response.data.deliveryTemplateId + ''
        this.formTitle = '修改'
        this.$set(this.form, 'specList', JSON.parse(JSON.stringify(response.data.specValueList)))
        let that = this
        this.form.photoAlbumArr = []
        if (this.form.photoAlbum) {
          this.form.photoAlbum.split(',').forEach((item) => {
            that.form.photoAlbumArr.push({
              uid: guid(8, 10),
              name: item,
              status: 'done',
              halfUrl: item,
              url: item,
              path: item,
            })
          })
        }
        this.form.pictureArr = []
        this.form.pictureArr.push({
          uid: guid(8, 10),
          name: that.form.picture,
          status: 'done',
          halfUrl: that.form.picture,
          url: that.form.picture,
          path: that.form.picture,
        })

        let skuList = this.form.skuList.map((its, j) => {
          return {
            cashCoupon: its.cashCoupon,
            id: its.id,
            image: its.image,
            barCode: its.barCode,
            weight: its.weight,
            price: its.price,
            requireScores: its.requireScores,
            skuName: its.skuName,
            skuNameEn: its.skuNameEn,
            skuNameRu: its.skuNameRu,
            specSpecValueList: its.specSpecValueList,
            stock: its.stock,
            imageArr: [
              {
                uid: guid(8, 10),
                name: its.image,
                status: 'done',
                halfUrl: its.image,
                url: its.image,
                path: its.image,
              },
            ],
          }
        })
        this.form.skuList = skuList
        console.log("详情", this.form.skuList)
        this.form.specValueList.forEach((iten, i) => {
          iten.tsName = iten.specName
        })
        const list2 = this.form.specValueList.reduce((pre, cur, index) => {
          let obj = {}
          if (index == 0) {
            obj.specId = cur.specId
            obj.id = cur.id
            obj.specValueList = [cur]
            pre.push(obj)
          } else {
            const i = pre.findIndex((item) => item.specId == cur.specId)
            if (i > -1) {
              pre[i].specValueList.push(cur)
            } else {
              obj.specId = cur.specId
              obj.id = cur.id
              obj.specValueList = [cur]
              pre.push(obj)
            }
          }
          return pre
        }, [])
        console.log("转换后", list2)
        this.form.specList = list2
      })
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    previewVideoCancel() {
      this.previewVideoVisible = false
    },
    // oss 上传开始
    async handlePreview(file) {
      let suffix = file.name.substring(file.name.lastIndexOf('.'))
      if (suffix === '.mp4') {
        this.handleVideoPreview(file)
      } else {
        this.handleImagePreview(file)
      }
    },
    handleVideoPreview(file) {
      if (!file.url && !file.preview) {
        file.preview =  this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewVideoVisible = true
    },
    handleImagePreview(file) {
      if (!file.url && !file.preview) {
        file.preview =  this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewImageVisible = true
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
      })
    },
    // 上传之前校验
    beforeOssUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 20
      // if (!isJPG) {
      //     this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 20MB!')
      }
      return isLt2M
    },


    //多图上传开始
    getUidRandom() {
      return Math.round(Math.random() * 80 + 20)
    },


    limitSort(sort) {
      let val = sort
      if (val == null || val == undefined || val == '') {
        val = 0
      }
      if (val > 999999) {
        val = 999999
      }
      this.form.sort = val
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info
            .map((ele) => {
              return ele.url
            })
            .join(',')
          this.form[`${fieldName}Arr`] = info
        }
      }
    },
    /**上传图片成功回调 */
    getImgs(info, fieldName, record) {
      if (info.length === 0) {
        record[fieldName] = ''
        record[`${fieldName}Arr`] = []
      } else {
        if (record[`${fieldName}Count`] === 1) {
          record[fieldName] = info[0].url
          record[`${fieldName}Arr`] = info
        } else {
          record[fieldName] = info
            .map((ele) => {
              return ele.url
            })
            .join(',')
          record[`${fieldName}Arr`] = info
        }
      }
      console.log("skuImage", record.image)
    },

    /** 提交按钮 */
    submitForm: function () {
      if (!this.validatorSku()) {
        return;
      }
      console.log(this.form, 'formtj', this.listGetData)
      this.form.goodStock = this.form.stock
      this.form.originalPrice = this.form.activityPrice
      this.form.specValueList = this.listGetData
      console.log("转换前skuList", this.form.skuList)
      var skuList = this.form.skuList.map((item, i) => {
        return {
          id: item.id,
          skuName: item.skuName,
          skuNameEn: item.skuNameEn,
          skuNameRu: item.skuNameRu,
          price: item.price,
          image: item.image,
          stock: item.stock,
          weight: item.weight,
          specSpecValueList: item.specSpecValueList,
        }
      })
      console.log("转换skuList", skuList)
      this.form.skuList = skuList
      var isSkuListTip = 0
      this.form.skuList.forEach((item) => {
        if (item.price == 0 || item.price == '' || item.stock == 0 || item.stock == '' || item.stock == null || item.image == null) {
          isSkuListTip = 1
        }
      })

      if (isSkuListTip == 1 && this.form.type != 1) {
        this.$message.error('商品库存和价格不能为空')
      } else {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true
            console.log(this.form, 'form', this.listGetData)
            if (this.codes == 1) {
              updateGoodsInfo(this.form)
                .then((response) => {
                  if (response.success) {
                    this.$message.success('修改成功', 3)
                    this.open = false
                    this.$emit('ok')
                  } else {
                    this.$message.error(response.message, 3)
                  }
                })
                .finally(() => {
                  this.submitLoading = false
                  this.$router.push({ path: '/mall/youxuan', replace: true, query: {} })
                })
            } else {
              addGoodsInfo(this.form)
                .then((response) => {
                  if (response.success) {
                    this.$message.success('新增成功', 3)
                    this.open = false
                    this.$emit('ok')
                  } else {
                    this.$message.error(response.message, 3)
                  }
                })
                .finally(() => {
                  this.submitLoading = false
                  this.$router.push({ path: '/mall/youxuan', replace: true, query: {} })
                })
            }
          } else {
            return false
          }
        })
      }
    },

  },

}
</script>
<style lang="less">
.goods-collapse > .ant-collapse-header {
  color: #007ffd !important;
  background: #e8eef9;
}
.box {
  position: relative;
  background-color: #f7f7f7;
  padding: 0 15px 15px 15px;
  margin-bottom: 15px;
  border-radius: 5px;

  .delSpec {
    position: absolute;
    right: -5px;
    top: -5px;
    color: #f5222d;
    cursor: pointer;
  }
}
</style>
